import { render, staticRenderFns } from "./DetailInversionEditor.vue?vue&type=template&id=8dafc122"
import script from "./DetailInversionEditor.vue?vue&type=script&lang=js"
export * from "./DetailInversionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports